// extracted by mini-css-extract-plugin
module.exports = {"image":"styles-module--image--3p4iv","circular":"styles-module--circular--2SkfZ"};